import React, { useState, useEffect } from "react";
import styled from "styled-components";

import FormGroup from "live/components/forms/ui/form-group";
import SubmitOrCancel from "live/components/forms/ui/submit-or-cancel";

import UserGroupBox from "./UserGroupBox";
import xhr from 'live/services/xhr'
import { createUserApi, updateUserApi } from "../../../api/userApi";
import i18n from 'live/services/i18n';
import './../../../../assets/scss/form.scss';
import { isEmailValid } from "../../../utils/utils";

const User = ({ user, company, selectUser, reloadUserList }) => {

  const [messageErrorName, setMessageErrorName] = useState("");
  const [messageErrorEmail, setMessageErrorEmail] = useState("");
  const [messageErrorResponseApi, setMessageErrorResponseApi] = useState();
  const [userSelected, setUserSelected] = useState({
    name: "",
    email: "",
    groups: [],
  });

  useEffect(() => {
    if (user.id) {
      setUserSelected(user);
    }
  }, []);

  const addGroup = (group) => {
    setUserSelected({
      ...userSelected,
      groups: [group, ...userSelected.groups],
    });
  };

  const removeGroup = (groupToRemove) => {
    setUserSelected({
      ...userSelected,
      groups: userSelected.groups.filter((group) => {
        return group.id != groupToRemove.id;
      }),
    });
  };

  const saveNewUser = () => {
    userSelected.companyID = company.id;
    const canSave = validName(userSelected.name) & validEmail(userSelected.email);
    

    if(canSave){
      if(userSelected.id){
        updateDB(userSelected);
      }
      else{
        saveDB(userSelected);
      }
    }
  };

  const saveDB = (userSelected) => {
    createUserApi(userSelected)
    .then(() => {
          sendPasswordReset();
          cancel();
      }
    )
    .catch(error => {
      setMessageErrorResponseApi(error?.response?.data?.message || error?.response?.data);
    });
  }

  const updateDB = (user) => {
    updateUserApi(user)
    .then((response) => {
        sendPasswordReset();
        cancel();
    })
    .catch(error => {
      setMessageErrorResponseApi(error?.response?.data?.message || error?.response?.data);
    })
    ;
  }

  const validEmail = (email) => {

    let isValid = true;
    setMessageErrorEmail("");

    if(email === ''){
      setMessageErrorEmail("Email can't be empty");
      isValid = false;
    }
    else if(isEmailValid(email) == false){
      setMessageErrorEmail("Email can't be invalid");
      isValid = false;
    }

    return isValid;
  }

  const validName = (name) => {
    let isValid = true;
    setMessageErrorName("");

    if(name === ''){
      setMessageErrorName("Name can't be empty");
      isValid = false;
    }

    return isValid;
  }

  const _handleOnChangeName = (event) => {        
    const name = event.target.value;
    validName(name);
    setUserSelected({...userSelected,  name});
  }

  const _handleOnChangeEmail = (event) => {    
    const email = event.target.value;
    validEmail(email);
    setUserSelected({...userSelected,  email });
  }

  const cancel = () => {
    selectUser(null);
    reloadUserList();
    setMessageErrorResponseApi();
  };

  const sendPasswordReset = () => {
    const { email } = userSelected;

    xhr
      .post("/rest/user/reset-password", email, {
        headers: { "Content-Type": "text/plain" },
      })
      .then(({ data }) => {
        // this.toggleModalInfo('success')
      })
      .catch(({ data }) => {
        // this.toggleModalInfo('error', data.message)
      });
  };

  return (
    <UserBox>
      <div className="user-data">
        <FormGroup
          className={messageErrorName !== '' ? 'custom-form-group-danger' : ''}
          type="text"
          disabled={false}
          label="Name"
          value={userSelected.name}
          onChange={_handleOnChangeName.bind(this)}
          help={messageErrorName !== '' ? i18n(messageErrorName) : ''}
        />
        <FormGroup
          className={messageErrorEmail !== '' ? 'custom-form-group-danger' : ''}
          type="text"
          disabled={false}
          label="E-mail"
          value={userSelected.email}
          onChange={_handleOnChangeEmail.bind(this)}
          help={messageErrorEmail !== '' ? i18n(messageErrorEmail) : ''}
        />
        {userSelected.id ? (
          <div className="form-group"
          >
            <p className="help-block regular">{"Password reset help"}</p>
            <a
              className="link-bold"
              onClick={() => sendPasswordReset()}
            >
              <i className="fa  fa-envelope-o" /> {"Send password reset"}
            </a>
          </div>
        ) : null}

        <SubmitOrCancel
          disabled={false}
          onSubmit={() => saveNewUser()}
          onCancel={() => cancel()}
          hideCancel={false}
        />

        <div class="custom-form-group-danger">
          <span class="custom-form-group-danger help-block">{messageErrorResponseApi}</span>
        </div>
      </div>
      <div className="user-users-group">
        <UserGroupBox
          company={company}
          user={userSelected}
          addGroup={addGroup}
          removeGroup={removeGroup}
        />
      </div>
    </UserBox>
  );
};

const UserBox = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;

  .user-data {
    flex: 1 1 auto;
    padding: 20px;
  }

  .user-users-group {
    flex: 0 1 300px;
  }
`;

export default User;
